import { useSelector, } from 'react-redux';
import { IGlobalStore, IReducerStore, } from '@Store';

export const useCall = (): IGlobalStore['call'] => {
  return useSelector((store: IReducerStore) => store.global.call);
};
